import { AfterViewInit, ChangeDetectionStrategy, Component, computed, ElementRef, inject, Injector, signal, viewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonButtonRowWidget, CommonForm, CommonTextField, CommonTextFieldWidget } from '@eforall/common';
import { DashboardDialogFramePart, DialogContext } from '@eforall/dashboard';
import { VolunteerSignupSpecialistWithAllTopics } from '@interfaces';
import { FuncService } from '../../../../../services';

@Component({
	selector: 'programs-specialist-sign-up-note-editor-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
		CommonTextFieldWidget,
		CommonButtonRowWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './specialist-sign-up-note-editor.dialog.html'
})

export class SpecialistSignUpNoteEditorDialog implements AfterViewInit {

	public dialogRef = inject(MatDialogRef<SpecialistSignUpNoteEditorDialog>);
	public dialogContext: DialogContext<VolunteerSignupSpecialistWithAllTopics> = inject(MAT_DIALOG_DATA);

	private func = inject(FuncService);

	public readonly commonForm = new CommonForm<{ note: string }>(inject(Injector));
	public formSaveBtn = viewChild.required<ElementRef<HTMLButtonElement>>('formSaveBtn');

	ngAfterViewInit(): void {
		this.commonForm.setSubmitButton(
			this.formSaveBtn(),
			async (values, changed: string[]) => {

				if (!this.dialogContext.data) return;

				await this.func.volunteering.specialistSignUp.updateSignUpData({
					volunteerSignupSpecialistId: this.dialogContext.data.volunteerSignupSpecialistId,
					note: values.note,
				});

				this.dialogRef.close();
			}
		);
	}

	revertValues() {
		this.commonForm.resetAll();
	}


	readonly note = computed<CommonTextField>(() => ({
		config: signal({ label: 'Note', min: 0, fixCase: 'sentence-case', isRequired: false, multiLine: true, isSpanish: false }),
		actualValue: computed(() => this.dialogContext.data?.note ?? ''),
		pendingValue: signal<string | null>(null),
		saving: signal(false),
		error: signal(''),
		formFieldName: 'note',
		form: this.commonForm
	}));

}